import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "popover-wrapper" }
const _hoisted_2 = { class: "popover-wrapper__content" }

import { ref, watch } from 'vue'
import CustomItem from './customItem.vue'
import { ICustomItem } from '../useData'


export default /*#__PURE__*/_defineComponent({
  __name: 'popoverSelect',
  props: {
    customList: null,
    initKey: null
  },
  setup(__props: any) {

const props = __props as { customList: Array<ICustomItem>, initKey: string }


// TODO: 12.20 主题屏蔽版本
// const popoverShowFlag = ref(false)
// const popoverShow = value => {
//   popoverShowFlag.value = value
// }
const selectItem = ref<ICustomItem>()
const selected = (select: ICustomItem, onSelect?: () => void) => {
  selectItem.value = select
  onSelect && onSelect()
}
watch(
  [() => props.initKey],
  () => {
    for (let i = 0; i < props.customList.length; i++) {
      if (props.customList[i].key === props.initKey) {
        selectItem.value = props.customList[i]
        return
      }
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.customList, (item, index) => {
        return (_openBlock(), _createBlock(CustomItem, {
          key: index,
          onClick: ($event: any) => (selected(item, () => item.onSelect && item.onSelect())),
          imgUrl: item.imgUrl,
          des: item.des,
          selectedFlag: selectItem.value?.key === item.key
        }, null, 8, ["onClick", "imgUrl", "des", "selectedFlag"]))
      }), 128))
    ])
  ]))
}
}

})